import { Controller } from 'stimulus';
import events from 'lib/events';
import { primeForPostLogin, triggerCustomEvent } from 'lib/helpers';

export default class ResourceFavoriteController extends Controller {
  sendAnalytics() {
    triggerCustomEvent(events.show_page.favorite, {
      resourceContentType: this.data.get('contentType'),
    });
  }

  favoriteAfterLogin = () => {
    const resourceControllerElem = document.querySelector('[data-controller*="resource-show-main"]');
    const { resourceId } = resourceControllerElem.dataset;

    primeForPostLogin('favorite_after_login', resourceId);
  }
}
